import { render, staticRenderFns } from "./sideView.vue?vue&type=template&id=338d6588&scoped=true&"
import script from "./sideView.vue?vue&type=script&lang=js&"
export * from "./sideView.vue?vue&type=script&lang=js&"
import style0 from "./sideView.vue?vue&type=style&index=0&id=338d6588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d6588",
  null
  
)

export default component.exports